import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1312d298 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _3c440110 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _62ff6b33 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _cecea6ea = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _90142daa = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _4c331e2a = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _1e8e6f2e = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _302769f8 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _7592f78d = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _0395f6ae = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _493c2dfc = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _d5d8c464 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _4d1c8eaa = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _1800123a = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _968c21e4 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _762cab16 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _694c116b = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _cebcd4e0 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _cc363620 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _d33785d6 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _e57f89b2 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _04b5429b = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _0fa6921c = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _508ee990 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _abd77a26 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _700a721a = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _960fbede = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _013a7712 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _cf088aa4 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _092a139f = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _e12f086c = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _2b0c9382 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _177c7fc4 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _7d6034c0 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _ef6aa38a = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _010aa663 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _08ff9cfb = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _1dc43195 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _519df815 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _282fce3e = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _9c090084 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _46c5692f = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _29d77a72 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _62688e7e = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _6def13b0 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _0d9e457c = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _1afeaeca = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _4aec592c = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _62b61d1e = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _77613ab9 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _60c62986 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _5fd41278 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _51452caa = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _602b4e10 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _24b0b8da = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _bd6a2428 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _6c18baf9 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _8b2c8338 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _87972370 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _6163ea1b = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _6996e8b2 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _4f64e32c = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _69950363 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _6c36ca00 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _dc76c34a = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _363c1987 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _a89b8b5a = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _3eb90d96 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _00fa43ea = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _3ff5a7c4 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _17865f18 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _52d30286 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _3d82189c = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _162a8894 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _1312d298,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _3c440110,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _62ff6b33,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _cecea6ea,
    name: "calendar"
  }, {
    path: "/customer",
    component: _90142daa,
    name: "customer"
  }, {
    path: "/details",
    component: _4c331e2a,
    name: "details"
  }, {
    path: "/goals",
    component: _1e8e6f2e,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _302769f8,
    name: "maisoku"
  }, {
    path: "/media",
    component: _7592f78d,
    name: "media"
  }, {
    path: "/privacy",
    component: _0395f6ae,
    name: "privacy"
  }, {
    path: "/project",
    component: _493c2dfc,
    name: "project"
  }, {
    path: "/response",
    component: _d5d8c464,
    name: "response"
  }, {
    path: "/achievement/output",
    component: _4d1c8eaa,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _1800123a,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _968c21e4,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _762cab16,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _694c116b,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _cebcd4e0,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _cc363620,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _d33785d6,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _e57f89b2,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _04b5429b,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _0fa6921c,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _508ee990,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _abd77a26,
    name: "response-registration"
  }, {
    path: "/setting/announcement",
    component: _700a721a,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _960fbede,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _013a7712,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _cf088aa4,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _092a139f,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _e12f086c,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _2b0c9382,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _177c7fc4,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _7d6034c0,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _ef6aa38a,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _010aa663,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _08ff9cfb,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _1dc43195,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _519df815,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _282fce3e,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _9c090084,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _46c5692f,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _29d77a72,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _62688e7e,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _6def13b0,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _0d9e457c,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _1afeaeca,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _4aec592c,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _62b61d1e,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _77613ab9,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _60c62986,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _5fd41278,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _51452caa,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _602b4e10,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _24b0b8da,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _bd6a2428,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _6c18baf9,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _8b2c8338,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _87972370,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _6163ea1b,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _6996e8b2,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _4f64e32c,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _69950363,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _6c36ca00,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _dc76c34a,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _363c1987,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _a89b8b5a,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _3eb90d96,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _00fa43ea,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _3ff5a7c4,
    name: "property-property",
    children: [{
      path: "contact",
      component: _17865f18,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _52d30286,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _3d82189c,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _162a8894,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
